export default __webpack_public_path__ + "static/media/dreamfest (6).53539777.jpg";